
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invest_business",
      function () {
        return require("private-next-pages/invest_business.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invest_business"])
      });
    }
  